import { render } from "./SelectTheam.vue?vue&type=template&id=48fb269c&scoped=true&ts=true"
import script from "./SelectTheam.vue?vue&type=script&lang=ts"
export * from "./SelectTheam.vue?vue&type=script&lang=ts"

import "./SelectTheam.vue?vue&type=style&index=0&id=48fb269c&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fb269c"]])

export default __exports__